export const CHART_HEIGHT = 164;
export const TICK_PADDING = 16;
